var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.educationList),function(education){return _c('v-flex',{key:education.id,staticClass:"px-1 py-1",attrs:{"xs12":"","md4":""}},[_c('education-card',{attrs:{"education":education}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }